import { Component, OnInit, EventEmitter, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  
  hideOldPassword = true;
  hideNewPassword = true;
  hideConfirmPassword = true;
  changePasswordFormGroup: FormGroup;

  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: any,
    private fb: FormBuilder) { }

    ngOnInit(): void {
      this.changePasswordFormGroup = this.createForm();
    }

    public createForm(): FormGroup {
      return this.fb.group({
        oldPassword: ['', [Validators.required]],
        newPassword: ['', [Validators.required]],
        confirmPassword: ['', [Validators.required]]
      });
    }


    handleChangePasswordSubmit(){}

}
